import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { UserlistComponent } from './userlist.component';

const routes: Routes = [
    {
        path     : 'userlist',
        component: UserlistComponent,
        data :{
            permission:{
                only :['role1','role2']
            }
        },
        canActivate:[AuthGuard,RoleGuard]
    }
];

@NgModule({
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        UserlistComponent
    ],
    providers:[
        AuthGuard,RoleGuard
    ]
})
export class UserlistModule
{
}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/userlist/userlist.module.ts